const reducer = (prev, updated) => ({...prev, ...updated});

export default reducer;